<template>
    <div class="login-container">
        <el-form ref="loginForm" class="login-form" auto-complete="on" label-position="left">
            <el-form-item>
                <span>아이디</span>
                <el-input :span="14" :offset="6"
                          name="loginForm"
                          v-model="loginForm.mb_id"
                          type="text"
                          auto-complete="on"
                />
            </el-form-item>

            <el-form-item>
                <span>비밀번호</span>
                <el-input
                        name="mb_password"
                        v-model="loginForm.mb_password"
                        :type="passwordType"
                        auto-complete="on"
                        @keyup.enter.native="userLogin"
                />
                <!--                <span class="show-pwd" @click="showPwd">-->
                <!--        </span>-->
            </el-form-item>
            <!--            <div class="login_find_link_wrap text_center">-->
            <!--            </div>-->
            <el-button class="submit-button" @click="userLogin" :disabled="btnDisabled">
                로그인
            </el-button>
        </el-form>
    </div>
</template>

<script>
    import alertMixins from "@/mixins/alertMixins";
    import {loginTokenSet, getTokenObj} from "@/mixins/Auth";
    import EventBus from "@/utils/event-bus";
    import Vue from "vue";
    import util from "@/mixins/util";
    import {LevelClass} from "@/mixins/level";

    export default {
        name: "LoginComponent",
        mixins: [alertMixins],
        components: {},
        data() {
            return {
                loginForm: {
                    mb_id: this.$route.query.mb_id ? this.$route.query.mb_id : '',
                    mb_password: this.$route.query.mb_password ? this.$route.query.mb_password : ''
                },
                passwordType: 'password',
                labelPosition: 'right',
                formLabelAlign: {
                    name: '',
                    region: '',
                    type: ''
                },
                passPath: ['/auth'],
                btnDisabled: false,
                LevelClass: new LevelClass(),
            }
        },

        created() {

        },
        mounted() {

        },

        methods: {
            async userLogin() {
                this.btnDisabled = true;
                let params = {
                    mb_id: this.loginForm.mb_id,
                    mb_password: this.loginForm.mb_password,
                };
                await this.$api.$auth.login(params)
                    .then((res) => { // 로그인 api 통신 후 결과 처리
                        let resultData = this.ReturnType(res.Data.Result.Info.type);
                        if (resultData === true) {
                            loginTokenSet(res.Data.Result.List);
                            this.checkLevel();
                            // this.$router.push('/student/member')


                        } else {
                            this.errorAlert(resultData);
                            this.btnDisabled = false;
                        }
                    });
            },

            checkLevel() {
                let tokenObj = getTokenObj();
                this.$api.$config.getGroup().then(res => res.Data.Result).then(res => {
                    if(res.Info.type != 1 || util.isEmpty(tokenObj.g_idx)) {
                        this.checkLevelFail();
                    }else{
                        let g_idx = tokenObj.g_idx;
                        let groupList = res.List;
                        this.makeGroupObj(g_idx, groupList);
                    }

                });
            },
            makeGroupObj(g_idx, groupList) {
                let groupIndex = groupList.findIndex(group => group.g_idx === g_idx);
                if(groupIndex < 0) {
                    this.checkLevelFail();
                }else{
                    let levelObj = {
                        level: groupList[groupIndex].g_level,
                        type: groupList[groupIndex].g_type,
                        isSuper: groupList[groupIndex].g_is_super === 1 ? true : false,
                    }
                    console.log(levelObj)
                    this.checkLoginLevel(levelObj);
                }
            },
            checkLoginLevel(levelObj) {
                if(levelObj.type === 'admin') {
                    this.checkLevelSuccess(levelObj);
                }else{
                    this.checkLevelFail('일반회원은 로그인을 할 수 없습니다.');
                }
            },
            checkLevelFail(errorMsg='로그인에 실패하였습니다.') {
                this.errorMsg = errorMsg;
                this.errorAlert(errorMsg)
                loginTokenSet('');
                this.$localStorage.remove('token');
            },
            checkLevelSuccess(levelObj) {
                this.LevelClass.setterLevelObj(levelObj);
                this.$router.push('/student/member');
            },
            ReturnType(type) {
                let typeNum = Number(type);
                switch (typeNum) {
                    case 1:
                        return true;
                   /* case -1:
                        return 'DB에러';
                    case -3:
                        return '아이디가 존재하지 않습니다.';
                    case -6:
                        return '비밀번호가 틀립니다.';*/
                    case -4:
                        return '탈퇴된 회원입니다.';
                    default:
                        return '로그인에 실패하였습니다.';
                }
            },

        }
    }
</script>

<style scoped>

</style>
